var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "akl" }, [
    _c("div", { staticClass: "bod-view-txt" }, [
      _c("div", { staticClass: "wrapper-memb-join" }, [
        _c(
          "div",
          {
            staticClass: "os_noticeRes quiz_wrap",
            staticStyle: { background: "#defcff" }
          },
          [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "widL posRe padTML padBML quiz_QnA marBL" },
              [
                _c("div", { staticClass: "widM padS amway-theme" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "radio-wrapper quiz_QnA_radio marTSM marBSM",
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-evenly"
                      }
                    },
                    [
                      _c(
                        "label",
                        { staticClass: "amw-radio-wrap radio-label focus" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.quizData.quiz01,
                                expression: "quizData.quiz01"
                              }
                            ],
                            staticClass: "amw-global-radio",
                            attrs: {
                              type: "radio",
                              name: "radio-1",
                              value: "true"
                            },
                            domProps: {
                              checked: _vm._q(_vm.quizData.quiz01, "true")
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(_vm.quizData, "quiz01", "true")
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "amw-radio-overlay" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "amw-label-radio-text" }, [
                            _vm._v("O")
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "label",
                        { staticClass: "amw-radio-wrap radio-label focus" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.quizData.quiz01,
                                expression: "quizData.quiz01"
                              }
                            ],
                            staticClass: "amw-global-radio",
                            attrs: {
                              type: "radio",
                              name: "radio-1",
                              value: "false"
                            },
                            domProps: {
                              checked: _vm._q(_vm.quizData.quiz01, "false")
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(_vm.quizData, "quiz01", "false")
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "amw-radio-overlay" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "amw-label-radio-text" }, [
                            _vm._v("X")
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm._m(2),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "radio-wrapper quiz_QnA_radio marTSM marBSM",
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-evenly"
                      }
                    },
                    [
                      _c(
                        "label",
                        { staticClass: "amw-radio-wrap radio-label focus" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.quizData.quiz02,
                                expression: "quizData.quiz02"
                              }
                            ],
                            staticClass: "amw-global-radio",
                            attrs: {
                              type: "radio",
                              name: "radio-2",
                              value: "true"
                            },
                            domProps: {
                              checked: _vm._q(_vm.quizData.quiz02, "true")
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(_vm.quizData, "quiz02", "true")
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "amw-radio-overlay" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "amw-label-radio-text" }, [
                            _vm._v("O")
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "label",
                        { staticClass: "amw-radio-wrap radio-label focus" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.quizData.quiz02,
                                expression: "quizData.quiz02"
                              }
                            ],
                            staticClass: "amw-global-radio",
                            attrs: {
                              type: "radio",
                              name: "radio-2",
                              value: "false"
                            },
                            domProps: {
                              checked: _vm._q(_vm.quizData.quiz02, "false")
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(_vm.quizData, "quiz02", "false")
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "amw-radio-overlay" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "amw-label-radio-text" }, [
                            _vm._v("X")
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm._m(3),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "radio-wrapper quiz_QnA_radio marTSM marBSM",
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-evenly"
                      }
                    },
                    [
                      _c(
                        "label",
                        { staticClass: "amw-radio-wrap radio-label focus" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.quizData.quiz03,
                                expression: "quizData.quiz03"
                              }
                            ],
                            staticClass: "amw-global-radio",
                            attrs: {
                              type: "radio",
                              name: "radio-3",
                              value: "true"
                            },
                            domProps: {
                              checked: _vm._q(_vm.quizData.quiz03, "true")
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(_vm.quizData, "quiz03", "true")
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "amw-radio-overlay" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "amw-label-radio-text" }, [
                            _vm._v("O")
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "label",
                        { staticClass: "amw-radio-wrap radio-label focus" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.quizData.quiz03,
                                expression: "quizData.quiz03"
                              }
                            ],
                            staticClass: "amw-global-radio",
                            attrs: {
                              type: "radio",
                              name: "radio-3",
                              value: "false"
                            },
                            domProps: {
                              checked: _vm._q(_vm.quizData.quiz03, "false")
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(_vm.quizData, "quiz03", "false")
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "amw-radio-overlay" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "amw-label-radio-text" }, [
                            _vm._v("X")
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "padTSM",
                      staticStyle: {
                        display: "flex",
                        "justify-content": "center",
                        gap: "0 1.3em",
                        "max-width": "400px",
                        width: "95%",
                        margin: "0 auto"
                      }
                    },
                    [
                      _c("div", { staticStyle: { width: "45%" } }, [
                        _c(
                          "a",
                          {
                            staticClass: "osResBtn01 txtC",
                            staticStyle: {
                              width: "100%",
                              height: "4em",
                              "padding-top": "1.2em",
                              "text-align": "center"
                            },
                            on: {
                              click: function($event) {
                                return _vm.layerPopOver(this, "#osLayerPop")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                  응모하기\n                "
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "txtC", staticStyle: { width: "45%" } },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "osResBtn01",
                              staticStyle: {
                                width: "100%",
                                height: "4em",
                                padding: "0.6em 0.5em 0.6em"
                              },
                              on: { click: _vm.hint }
                            },
                            [
                              _vm._v("힌트보기"),
                              _c("br"),
                              _vm._v(" "),
                              _c("span", { staticClass: "fntE regular" }, [
                                _vm._v("(카드 자세히보기)")
                              ])
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "layerWrapper",
                class: { active: _vm.isPopup },
                attrs: { id: "osLayerPop" }
              },
              [
                _c(
                  "div",
                  { staticClass: "cbox layerBox popWidM layerCenterFlex" },
                  [
                    _c("div", { staticClass: "cart-popup__dialog" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "cart-popup__content payment amway-theme quiz_popUp"
                        },
                        [
                          _c("div", { staticClass: "os_noticeRes" }, [
                            _vm._m(4),
                            _vm._v(" "),
                            _vm._m(5),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass: "bold fntE widM",
                                staticStyle: { "padding-bottom": "5px" }
                              },
                              [_vm._v("개인정보 수집 · 이용 동의")]
                            ),
                            _vm._v(" "),
                            _vm._m(6),
                            _vm._v(" "),
                            _c("p", { staticClass: "fntE bold widM padTS" }, [
                              _vm._v(
                                "본인은 위 개인정보 수집 ∙ 이용에 동의합니다."
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "amway-theme marTS" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "radio-wrapper",
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "center",
                                    gap: "0 2em"
                                  }
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "amw-radio-wrap radio-label focus quiz_popUp_radio"
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "amw-label-radio-text",
                                          staticStyle: { margin: "0 5px 0 0" }
                                        },
                                        [_vm._v("동의")]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.useYnCheck.useYn01,
                                            expression: "useYnCheck.useYn01"
                                          }
                                        ],
                                        staticClass: "amw-global-radio",
                                        attrs: {
                                          type: "radio",
                                          name: "radio-4",
                                          value: "true"
                                        },
                                        domProps: {
                                          checked: _vm._q(
                                            _vm.useYnCheck.useYn01,
                                            "true"
                                          )
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.$set(
                                              _vm.useYnCheck,
                                              "useYn01",
                                              "true"
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticClass: "amw-radio-overlay"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "amw-radio-wrap radio-label focus quiz_popUp_radio"
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "amw-label-radio-text",
                                          staticStyle: { margin: "0 5px 0 0" }
                                        },
                                        [_vm._v("미동의")]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.useYnCheck.useYn01,
                                            expression: "useYnCheck.useYn01"
                                          }
                                        ],
                                        staticClass: "amw-global-radio",
                                        attrs: {
                                          type: "radio",
                                          name: "radio-4",
                                          value: "false"
                                        },
                                        domProps: {
                                          checked: _vm._q(
                                            _vm.useYnCheck.useYn01,
                                            "false"
                                          )
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.$set(
                                              _vm.useYnCheck,
                                              "useYn01",
                                              "false"
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticClass: "amw-radio-overlay"
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass: "bold fntE widM marTSM",
                                staticStyle: { "padding-bottom": "5px" }
                              },
                              [_vm._v("개인정보 제3자 제공 동의")]
                            ),
                            _vm._v(" "),
                            _vm._m(7),
                            _vm._v(" "),
                            _c("p", { staticClass: "fntE bold widM padTS" }, [
                              _vm._v(
                                "본인은 위 개인정보 제3자 제공에 동의합니다."
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "amway-theme marTS marBSM" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "radio-wrapper",
                                    staticStyle: {
                                      display: "flex",
                                      "justify-content": "center",
                                      gap: "0 2em"
                                    }
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "amw-radio-wrap radio-label focus quiz_popUp_radio"
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "amw-label-radio-text",
                                            staticStyle: { margin: "0 5px 0 0" }
                                          },
                                          [_vm._v("동의")]
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.useYnCheck.useYn02,
                                              expression: "useYnCheck.useYn02"
                                            }
                                          ],
                                          staticClass: "amw-global-radio",
                                          attrs: {
                                            type: "radio",
                                            name: "radio-5",
                                            value: "true"
                                          },
                                          domProps: {
                                            checked: _vm._q(
                                              _vm.useYnCheck.useYn02,
                                              "true"
                                            )
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.$set(
                                                _vm.useYnCheck,
                                                "useYn02",
                                                "true"
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "amw-radio-overlay"
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "amw-radio-wrap radio-label focus quiz_popUp_radio"
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "amw-label-radio-text",
                                            staticStyle: { margin: "0 5px 0 0" }
                                          },
                                          [_vm._v("미동의")]
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.useYnCheck.useYn02,
                                              expression: "useYnCheck.useYn02"
                                            }
                                          ],
                                          staticClass: "amw-global-radio",
                                          attrs: {
                                            type: "radio",
                                            name: "radio-5",
                                            value: "false"
                                          },
                                          domProps: {
                                            checked: _vm._q(
                                              _vm.useYnCheck.useYn02,
                                              "false"
                                            )
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.$set(
                                                _vm.useYnCheck,
                                                "useYn02",
                                                "false"
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "amw-radio-overlay"
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "txtC marBML" }, [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "bt-akl-blue btn_close quiz_popUp_btn",
                                  attrs: { href: "#", id: "close_btn" },
                                  on: { click: _vm.checkYn }
                                },
                                [_vm._v("확인")]
                              )
                            ])
                          ])
                        ]
                      )
                    ])
                  ]
                )
              ]
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "osResHeader padTXM padBXX" }, [
      _c("div", { staticClass: "widM txtC" }, [
        _c("img", {
          staticStyle: { "max-width": "505px", width: "80%" },
          attrs: {
            src:
              "https://www.amway.co.kr/_ui/responsive/theme-blue/images/akl_common/quizPromo_tit.png",
            alt:
              "퀴즈 풀고, 스타벅스 커피 받자! 암웨이-현대카드M Edition2 새로운 플레이트 출시 기념 퀴즈 이벤트"
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", [
      _c("li", { staticClass: "fntH6 regular" }, [
        _c(
          "span",
          { staticClass: "bolder", staticStyle: { color: "#002f5f" } },
          [_vm._v("01.")]
        ),
        _vm._v(
          " 한국암웨이에서 암웨이-현대카드M\n                Edition2로 이용하면, M포인트와 A포인트가 동시 적립 된다?"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", [
      _c("li", { staticClass: "fntH6 regular" }, [
        _c(
          "span",
          { staticClass: "bolder", staticStyle: { color: "#002f5f" } },
          [_vm._v("02.")]
        ),
        _vm._v(
          " 암웨이-현대카드M Edition2를 한국암웨이에서 이용하면 M포인트와 A포인트가 전월 실적 및 한도 제한 없이 적립된다?"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", [
      _c("li", { staticClass: "fntH6 regular" }, [
        _c(
          "span",
          { staticClass: "bolder", staticStyle: { color: "#002f5f" } },
          [_vm._v("03.")]
        ),
        _vm._v(" 스마트페이는 모든 신용카드로 이용할 수\n                있다?")
      ]),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "fntE",
          staticStyle: {
            "padding-top": "5px",
            "padding-left": "2em",
            "text-indent": "0em"
          }
        },
        [
          _vm._v(
            "*스마트페이란, 구매 즉시 총 PV/BV를 첫 달에 수령할 수 있는 최대 36개월 분할납부 방식의 구매\n                프로그램으로, 높은 할부 이자 부담을 줄일 수 있습니다."
          )
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "txtC padTL padBL",
        staticStyle: { background: "#ede6ff" }
      },
      [
        _c("img", {
          staticStyle: { "max-width": "216px", width: "44%" },
          attrs: {
            src:
              "https://www.amway.co.kr/_ui/responsive/theme-blue/images/akl_common/quizPromo_popUp.png",
            alt: ""
          }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "fntH6 bold txtC padTM padBM" }, [
      _vm._v("아래 개인정보 제공 및 이용 동의에 동의해 "),
      _c("br"),
      _vm._v("주셔야 응모가 완료됩니다.")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "widM padTM padBM",
        staticStyle: { background: "#f4f4f4" }
      },
      [
        _c("div", { staticClass: "widM fntE" }, [
          _c("p", { staticClass: "bold" }, [
            _vm._v(
              "한국암웨이㈜는 암웨이-현대 제휴카드 프로모션 “퀴즈 풀고 스타벅스 커피 받자!” 참여를 위하여 다음과 같이 귀하의\n                        개인정보를 수집, 이용합니다."
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "osResNoticeList",
              staticStyle: { "padding-top": "5px" }
            },
            [
              _c("ul", [
                _c("li", [
                  _vm._v("○ 수집하는 개인정보의 항목: 성명, 휴대 전화번호")
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v("○ 개인정보의 수집 및 이용 목적:"),
                  _c("br"),
                  _vm._v(
                    "- 이벤트 응모 고객 확정, 대상자 선정, 프로모션 혜택 등 이벤트 진행"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v("○ 개인정보의 보유 및 이용기간:"),
                  _c("br"),
                  _c("b", [_vm._v("이벤트 종료 후 3개월 동안 보유")]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "*단 사진 및 영상의 경우, 이미 게재된 경우를 제외\n                            합니다."
                  )
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "osResWarning" }, [
            _c("p", { staticClass: "padTS" }, [
              _c("b", [
                _vm._v(
                  "※ 귀하는 위 동의를 거부할 권리가 있으나, 이에 동의하지 않는 경우 암웨이-현대 제휴카드 프로모션 "
                ),
                _c("em", { staticClass: "disIb" }, [
                  _vm._v("“퀴즈 풀고 스타벅스 커피 받자!”")
                ]),
                _vm._v(" 참여가 불가합니다.")
              ])
            ])
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "widM padTM padBM",
        staticStyle: { background: "#f4f4f4" }
      },
      [
        _c("div", { staticClass: "widM fntE" }, [
          _c("p", { staticClass: "bold" }, [
            _vm._v(
              "한국암웨이㈜는 암웨이-현대 제휴카드 프로모션 “퀴즈 풀고, 스타벅스 커피 받자!” 참여를 위하여 다음과 같이 귀하의\n                        개인정보를 제3자에 대하여 제공합니다."
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "osResNoticeList",
              staticStyle: { "padding-top": "5px" }
            },
            [
              _c("ul", [
                _c("li", [_vm._v("○ 개인정보를 제공 받는 자: (주)현대카드")]),
                _vm._v(" "),
                _c("li", [
                  _vm._v("○ 개인정보를 제공 받는 자의 개인정보 이용 목적:"),
                  _c("br"),
                  _vm._v(
                    "- 이벤트 응모 고객 확정, 대상자 선정, 프로모션 혜택\n                            등 이벤트 진행"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v("○ 제공하는 개인정보의 항목: 성명, 휴대 전화번호")
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "○ 개인정보를 제공받는 자의 개인정보 보유 및 이용기간 :"
                  ),
                  _c("br"),
                  _vm._v("이벤트 종료 후 3개월 동안 보유")
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "osResWarning" }, [
            _c("p", { staticClass: "padTS" }, [
              _c("b", [
                _vm._v(
                  "※ 귀하는 위 동의를 거부할 권리가 있으나, 이에 동의하지 않는 경우 암웨이-현대 제휴카드 프로모션 "
                ),
                _c("em", { staticClass: "disIb" }, [
                  _vm._v("“퀴즈 풀고, 스타벅스 커피 받자!”")
                ]),
                _vm._v(" 참여가 불가합니다.")
              ])
            ])
          ])
        ])
      ]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2324db44", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2324db44","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/affiliatecard/quiz/affiliateCardQuiz.vue
// module id = null
// module chunks = 